import EnumSet from 'Services/enumSet'

interface IInvoiceStatus extends EnumSet {
  none: number
  success: number
  waiting: number
  error: number
}

const InvoiceStatus = new EnumSet({
  none: { value: 0, description: 'Nenhum' },
  success: { value: 1, description: 'Sucesso' },
  waiting: { value: 2, description: 'Aguardando' },
  error: { value: 3, description: 'Erro' },
}) as IInvoiceStatus

export default InvoiceStatus